import { z } from 'zod';
import { REQUEST_INVALID_CODE } from './request-invalid.js';
const SCREAMING_SNAKE = /^[A-Z][A-Z0-9_]*$/;
/** 비즈니스 오류 코드 계약. SCREAMING_SNAKE만 통과시킨다. */
export const businessErrorCodeSchema = z
    .string()
    .regex(SCREAMING_SNAKE, '비즈니스 오류 코드는 SCREAMING_SNAKE여야 한다.');
/**
 * 값이 계약에 맞는 비즈니스 오류 코드인지 본다.
 * 사람 문구·Nest 기본 message는 코드로 쓰지 않기 위해 형식을 좁힌다.
 */
export function isApiBusinessErrorCode(value) {
    // 요청 계약 코드는 비즈니스 카탈로그와 섞지 않는다.
    return typeof value === 'string' && SCREAMING_SNAKE.test(value) && value !== REQUEST_INVALID_CODE;
}
/**
 * 서버가 던질 코드를 브랜드 타입으로 고정한다.
 * 형식이 아니면 잘못된 카탈로그 값이 응답에 나가지 않게 바로 실패한다.
 */
export function asApiBusinessErrorCode(code) {
    if (!isApiBusinessErrorCode(code)) {
        throw new Error('비즈니스 오류 코드는 SCREAMING_SNAKE 문자열이어야 한다.');
    }
    return code;
}
//# sourceMappingURL=business-error-code.js.map